import React, { Fragment, useEffect, useState } from 'react'
import GameCard from './GameCard'
import styled, { css } from 'styled-components'
//import { Text } from '@it25syv/25syv-ui'
import { UI_CONFIG } from '../configs/ui'
import { HighlightBox } from '../styled'
import PropTypes from 'prop-types'

const t = window.T

const MAX_NUMBER_OF_GAMES = 200

const Text = styled.p``
const GameHolder = styled.div`
    position: relative;
    padding: ${(props) => (props.itemPadding ? props.itemPadding : 'initial')};
    ${(props) =>
        props.thumb &&
        css`
            grid-column: ${(props) => (props.index % 2 ? '3/5' : '1/3')};
            grid-row: 1/3;
        `};

    &:hover {
        cursor: pointer;
    }
`

const ThumbWrapper = styled.div`
    display: inline-block;
    justify-content: center;
    transition: all 0.3s ease;
    width: ${({ width }) => (width ? width : 'auto')};
    position: relative;
    line-height: 0; //removing space between picture and border
`

const GameText = styled(Text)`
    text-align: center;
    position: relative;
    top: 5px;
    color: ${UI_CONFIG.textColor};
    margin: 0;
    line-height: 1.3;
    font-size: 16px;
`

const MinStake = styled(HighlightBox)`
    display: inline-block;
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 0 5px;
    font-size: 0.7rem;
    border-radius: 4px;
    position: absolute;
    bottom: 13px;
    right: 7px;
`

const GameList = ({
    games = [],
    limit = MAX_NUMBER_OF_GAMES,
    itemPadding = 'initial',
    lazyOverflow = false,
    gameClickHandler,
}) => {
    const [gamesForRender, setGamesForRender] = useState([])
    const [keyUpdate, setKeyUpdate] = useState(0)

    useEffect(() => {
        setGamesForRender(games)
    }, [games])

    return (
        <Fragment key={keyUpdate}>
            {gamesForRender.length > 0 &&
                gamesForRender.map((game, index) => {
                    return (
                        index < limit && (
                            <GameHolder
                                key={'gamesList-' + index}
                                itemPadding={itemPadding}
                                index={index}
                            >
                                <ThumbWrapper width={'100%'}>
                                    <GameCard
                                        key={game.id}
                                        game={game}
                                        gameClickHandler={gameClickHandler}
                                        lazyOverflow={lazyOverflow}
                                    />
                                </ThumbWrapper>
                            </GameHolder>
                        )
                    )
                })}
        </Fragment>
    )
}

GameList.propTypes = {
    games: PropTypes.arrayOf(PropTypes.object).isRequired,
    limit: PropTypes.number,
    lazyOverflow: PropTypes.bool,
    itemPadding: PropTypes.string,
    gameClickHandler: PropTypes.func,
}

export default GameList
